import { EXTENSION_STYLES } from "./constants";

export const getExtensionLabel = (extension: string) => extension.replace(".", "").toUpperCase();

export const getExtensionStyles = (extension: string) =>
  EXTENSION_STYLES[getExtensionLabel(extension)] || {
    backgroundColor: "#EEF2F7",
    color: "#5F6B7A",
  };
